import { API } from "aws-amplify";

export default async function getStatementPDF(id) {
  if (id) {
    return await API.get("statements", `/${id}/pdf`, { responseType: "blob" });
  }
}
